WB.DataServices = WB.DataServices || {};

WB.DataServices.Observation = function ($http, $q, _Config, UnitUtility) {

    var _this = this;

    this.ContentMgmtUrl = _Config.BaseURLs.ContentMgmt.Prod;

    this.GetObservationForLocation = function(location) {
        var stationId = location.Station ? location.Station.StationId : null,
                providerId = location.Station ? location.Station.ProviderId : null;

        return _this.GetObservationForLatLng(
            location.Locality.Latitude,
            location.Locality.Longitude,
            stationId,
            providerId);
    };

    this.GetObservationForLocality = function(locality) {
        return _this.GetObservationForLatLng(locality.Latitude, locality.Longitude);
    };

    this.getFTemp = function (temp) {
        try {
            temp = parseInt(temp);
        } catch (ex) {
            return temp;
        }
        if (isNaN(temp)) return '';
        return UnitUtility.convertCtoF(temp);

    };

    this.GetObservationForLatLng = function(lat, lng, stationId, providerId) {
        return $q(function(resolve, reject) {

            var params = {
                lat: lat,
                lng: lng
            };
            if (stationId) {
                params.stationId = stationId;
            }
            if (providerId) {
                params.providerId = providerId;
            }
            //params.timestamp = new Date().getTime();

            $http({
                url: '/api/observation',
                method: 'GET',
                params: params
            })
                .success(function(observationAggregate) {
                    resolve(observationAggregate);
                })
                .error(function() {
                    reject(new Error('Unable to get observation.'));
                });

        });
    };

};
WB.DataServices.Observation.$inject = ['$http', '$q', '_Config', 'UnitUtility'];

WB.Core.service('ObservationDataService', WB.DataServices.Observation);
